import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { BlacklistAddress, BlacklistAddressInput } from '@/models/blacklistAddress';

export const createBlacklistAddress = async (data: BlacklistAddressInput): Promise<BlacklistAddress> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateAddress($data: AddressInputType!) {
        createAddress(data: $data) {
          id
          name
          phoneNumber
          streetAddress
          streetAddress2
          city
          state
          country
          zip
          latitude
          longitude
          radius
          reason
          blackListedAt
          flaggedAt
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createAddress!;
};
